export default "__VITE_ASSET__DSkEmiSV__"